module.exports = __webpack_public_path__ + "img/southland-logo.ff7e94a8.jpg";